<template>
<div id="EditUser">
<b-modal id="modal-sm" size="md" title="Role Permission" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
  <div slot="default">
    <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
    <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
   </div> 
  <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
         <b-button variant="primary"  size="md"  class="float-right"  @click="PopMsgClose"> Close </b-button>
      </div>
</b-modal>
    <div class="form-group row my-1" v-show="false">
    <label for="SearchClinics" class="col-sm-4 col-form-label-xs">Location:</label>
    <div class="col-sm-7">
      <vue-bootstrap-typeahead ref="SearchClinic"  :inputClass="TypeHeadinptClass"  v-model="searchloc"  :data="Locations"  @hit="SelectedClinic = $event"
          :serializer="item => item.text"  textVariant=".text-primary"   placeholder="Search Clinic"  size="sm"  backgroundVariant="bg-light" :maxMatches="20" >
          <template slot="prepend">
          <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
          </template>                      
      </vue-bootstrap-typeahead>      
     </div> 
    <div :class="{ 'col-sm-1 my-0': $v.SelectedClinic.$error}"   v-show="$v.SelectedClinic.$error" >
        <div class="row">
    <small class="sml-red" v-if="!$v.SelectedClinic.required">Search Clinic.</small>
    </div>
    </div> 
    </div> 
  <form>  
  <div class="form-group row  my-0">
    <label for="UserID" class="col-sm-4 label-small my-0">User ID:</label>
    <div class="col-sm-4 my-0">
      <input id="UserID" disabled="true" v-model="uid" placeholder="User ID" class="form-control form-control-xs my-0 mb-0">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.uid.$error}"   v-show="$v.uid.$error">
       <div class="row">
        <small class="sml-red" v-if="!$v.uid.required">User ID is required.</small>
        </div>
       <div class="row">
         <small class="sml-red" v-if="!$v.uid.minLength">Minimum 7 characters. 
           </small>
        </div>
        <div class="row">
         <small class="sml-red" v-if="!$v.uid.maxLength">Maximum 7 characters. 
           </small>
        </div>        
    </div>
  </div>
   <div class="form-group row  my-0" >
    <div class="col-sm-4 my-0"></div>
    <div class="col-sm-8 mr-0 my-0" v-show="false">
      <small class="sml-red">UID: Must be 7 characters.</small>
    </div>
  </div>    
  <!-- <div class="form-group row  my-0">
    <label for="usernm" class="col-sm-4  label-small my-0">User Name:</label>
    <div class="col-sm-4 my-0">
       <input id="usernm" v-model="username" placeholder="User Name" class=" my-0 form-control form-control-xs">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.username.$error}"   v-show="$v.username.$error">
        <div class="row">
         <small class="sml-red" v-if="!$v.username.minLength">Minimum 3 characters. 
           </small>
        </div>
        <div class="row">
         <small class="sml-red" v-if="!$v.username.maxLength">Maximum 50 characters. 
           </small>
        </div>        
    </div>
  </div>  -->
 <div class="form-group row my-0 mt-1">
    <label  class="col-sm-4 label-small">Service Type:</label>
    <div class="col-sm-4">
         <select v-model="selectService" :disabled="DisableService"  class="form-control form-control-xs">
            <!-- <option disabled value="" selected="selected">Select Service</option> -->
             <option v-for="option in Services" v-bind:value="option.serviceid" :key="option.serviceid">
              {{ option.service }}
            </option>
          </select>
     </div>
    <div :class="{ 'col-sm-4 mb-0': $v.selectService.$error}"   v-show="$v.selectService.$error"> 
          <div class="row">
         <small class="sml-red" v-if="!$v.selectService.required">Select Service 
           </small>
        </div> 
    </div>
  </div>     
  
  <div v-if="(selectService == 6)" class="form-group row  my-1">
    <label for="usernm" class="col-sm-4  label-small my-0">First Name:</label>
    <div class="col-sm-4 my-0">
      <input id="usernm" v-model="firstname" placeholder="First Name" class=" my-0 form-control form-control-xs">
       <!-- <input :disabled="!(selectService == 6)" id="usernm" v-model="firstname" placeholder="First Name" class=" my-0 form-control form-control-xs"> -->
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.firstname.$error}"   v-show="$v.firstname.$error">
        <!-- <div class="row">
         <small class="sml-red" v-if="!$v.firstname.minLength">Minimum 3 characters. 
           </small>
        </div> -->
        <div class="row">
         <small class="sml-red" v-if="!$v.firstname.maxLength">Maximum 25 characters. 
           </small>
        </div>       
    </div> 
  </div> 

  <div v-if="!(selectService == 6)" class="form-group row  my-1">
    <label for="usernm" class="col-sm-4  label-small my-0">Organization Name:</label>
    <div class="col-sm-4 my-0">
       <input id="usernm" v-model="firstname" placeholder="Organization Name" class=" my-0 form-control form-control-xs">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.firstname.$error}"   v-show="$v.firstname.$error">
        <!-- <div class="row">
         <small class="sml-red" v-if="!$v.firstname.minLength">Minimum 3 characters. 
           </small>
        </div> -->
        <div class="row">
         <small class="sml-red" v-if="!$v.firstname.maxLength">Maximum 25 characters. 
           </small>
        </div>       
    </div> 
  </div> 

  <div v-if="(selectService == 6)" class="form-group row  my-0">
    <label for="usernm" class="col-sm-4  label-small my-0">Last Name:</label>
    <div class="col-sm-4 my-0">
       <!-- <input :disabled="!(selectService == 6)" id="usernm" v-model="lastname" placeholder="Last Name" class=" my-0 form-control form-control-xs"> -->
       <input id="usernm" v-model="lastname" placeholder="Last Name" class=" my-0 form-control form-control-xs">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.lastname.$error}"   v-show="$v.lastname.$error">
        <!-- <div class="row">
         <small class="sml-red" v-if="!$v.lastname.minLength">Minimum 3 characters. 
           </small>
        </div> -->
        <div class="row">
          <small class="sml-red" v-if="!$v.lastname.maxLength">Maximum 25 characters. 
           </small>
        </div>       
    </div>
  </div> 

  <div v-if="!(selectService == 6)" class="form-group row  my-0">
    <label for="usernm" class="col-sm-4  label-small my-0">Unit Name:</label>
    <div class="col-sm-4 my-0">
       <!-- <input :disabled="!(selectService == 6)" id="usernm" v-model="lastname" placeholder="Last Name" class=" my-0 form-control form-control-xs"> -->
       <input id="usernm" v-model="lastname" placeholder="Unit Name" class=" my-0 form-control form-control-xs">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.lastname.$error}"   v-show="$v.lastname.$error">
        <!-- <div class="row">
         <small class="sml-red" v-if="!$v.lastname.minLength">Minimum 3 characters. 
           </small>
        </div> -->
        <div class="row">
          <small class="sml-red" v-if="!$v.lastname.maxLength">Maximum 25 characters. 
           </small>
        </div>       
    </div>
  </div> 

  <div class="form-group row  my-1">
    <label for="usernm" class="col-sm-4  label-small my-0">Phone Number:</label>
    <div class="col-sm-4 my-0">
       <input type="tel" id="phonenm" v-model="phonenumber" placeholder="Optional" class=" my-0 form-control form-control-xs">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.phonenumber.$error}"   v-show="$v.phonenumber.$error">
        <div class="row">
         <!-- <small class="sml-red" v-if="!$v.phonenumber.minLength">Minimum 10 digits.</small> -->
        
         <small class="sml-red" v-if="!$v.phonenumber.isPhone">Phone number is invalid</small>
        </div>       
    </div>
  </div> 

  <div class="form-group row  my-1">
    <label for="usernm" class="col-sm-4  label-small my-0">Email:</label>
    <div class="col-sm-4 my-0">
       <input type="email" maxlength="56" id="EmailAddress" v-model="emailaddress" placeholder="Optional" class=" my-0 form-control form-control-xs">
    </div>
    <div  :class="{ 'col-sm-4 my-0': $v.emailaddress.$error}" v-show="$v.emailaddress.$error">
      <div class="row" >
        <!-- <small class="sml-red" v-if="!$v.emailaddress.required">Email is required</small> -->
        <small class="sml-red" v-if="!$v.emailaddress.email">Email is invalid</small>
        </div> 
    </div>
  </div> 

  <div class="form-group row  my-1">
    <label for="todate" class="col-sm-4  label-small my-0">Expiry Date:</label>
          <div class="col-sm-4 my-0">
         
             <datepicker  
                :disabledDates= "disableExpDate"
                :disabled= "IsPast"
                type="date"
                class="servdatapick"
                :open-date="new Date()"
                v-model="toDate"
                :format="DateFormat"
                id="todate"
                :bootstrap-styling="true"
                :input-class="datapickClass"
                name="toDatepicker"
            ></datepicker> 
        
        </div>
        <!-- <div  class="row" v-show="$v.toDate.$error">
            <div class="col-sm-12">     
              <small class="sml-red" v-if="!$v.toDate.required">To Date is required.</small>            
              <small class="sml-red" v-if="!$v.toDate.ValidValue">To Date is invalid.</small>              
            </div>
        </div>   -->
        </div>

</form>
<hr>
<div class="row">
    <div class="col-sm-6">
        <button v-on:click="EditUser" type="button" class="btn BtnSave btn-sml"><i class="fas fa-plus"></i> Edit User </button>
    </div>
     
    <div class="col-sm-6">
        <button v-on:click="Exit" type="button" class="btn BtnClose btn-sml"> <i class="fas fa-times"></i> Close Form  </button>
    </div>
</div> 
  
 </div>
   
</template>

<script>
 
import axios from 'axios'
import Vue from 'vue'; 
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators' 
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {required,minLength,email,sameAs, not, maxLength,numeric,requiredIf} from 'vuelidate/lib/validators'
import { emailFormatter } from '@/Common/Default/EmailFormatter'
const isPhone = helpers.regex('alphaNum', /\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)
import { notEqual } from 'assert'; 
Vue.use(Vuelidate);
const PasswordCheck = helpers.regex('alphaNum', /(?=.{0,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/)
export default {
   props:{UserData:Object},
   data: function () {
    return {
        Recid: '',
        DisableService :true,
        SelectedClinic:'',
        TypeHeadinptClass:'form-control form-control-xs',
        SearchClinics:'Search Clinics',
        datapickClass:"form-control form-control-xs my-0",
        disableExpDate: { to: new Date(Date.now() - 8640000) },
        todayDate: moment().format('YYYY/MM/DD'),
        IsPast: false,
        toDate: '',
        oldPassword:'',
        newPassword:'',
        confirmPassword:'',
        PWDminLength: 0,
        updateMessage:'',
        showUpdate:true,
        showOldPassword:true,
        uid:'',
        username: '',
        password: '',
        phonenumber: '',
        emailaddress: '',
        f: '',
        lastname: '',
        activeColor: 'red',
        fontSize: 30,
        StartDate: '',
        EndDate: '',            
        locnum: '',       
        selectLocation: '',
        searchloc: '',
        Locations:[],
        location: '',
        loclist: '',
        selectService: '',
        Services:[],
        selectRole: '',
        Roles:[], 
        Datepicker: '', 
        adduser: '',
        exit: '',
        DateFormat: '',
        succeeded: false,
        Msg:'',
        showModal:false,
        ServiceType: '',
        UserClinicNo:'' ,
        UserServiceId:'' 
    }
    },
    watch :{
     SelectedClinic:function(val){
        ////console.log('clinci change= ' + val.serviceid)
        if(val)
        {
          if(val.serviceid != this.UserServiceId){
            //console.log(this.Services);
            //console.log(val.serviceid)
            const clinicservicetype = this.Services.find(obj => {
                  return obj.serviceid === val.serviceid;
                }).service;
            ////console.log(clinicservicetype);
            //var find = _.find(this.Services, ['serviceid', val.serviceid]);
            // //console.log('find = ' + this.clinicservicetype)  ;
            //var clinicservicetype = this.Services.find(x=>x.service === 'Dental');
            ////console.log('clinic servicetype = ' +clinicservicetype)  ;
            this.selectService = null;
            this.showMsg('User role service type is "' + this.ServiceType + '" and clinic service type is "' + clinicservicetype +'", please terminate "'+this.uid +'" user and add this user as a new user.',null,'Edit User Clinic Error!')
          }
          else
          {
              this.selectService = val.serviceid;
              //console.log(this.selectService)
          }
        }
     },
     selectService :function(val){
       if(val)
       {
          this.fillroles();
          this.DisableService =true;
       }
     },
    },
    components: {
        Datepicker,         
    },    
    methods: {
        
        EditUser: function (event) {
         //  //console.log(this.SelectedClinic)
        // //console.log(this.$v)
        // //console.log(this.$v.$invalid)
        this.$v.$touch();
          
          if (!this.$v.$invalid){  
           //  //console.log('here')
          var vm = this; 
          //  if(((moment(vm.EndDate)).toISOString() >= moment(new Date("12/31/9998")).startOf('day').toISOString()))
          // {
          //   vm.EndDate = moment(new Date("12/31/9999")).startOf('day');
          // }
          // else{
          //   vm.EndDate = moment(vm.EndDate).startOf('day');
          // }
          // vm.StartDate = moment(vm.StartDate).startOf('day');
         // //console.log(vm.SelectedClinic)
          var url = "/SaskHealthApi/Security/PostEditUserClinic/"
          var params = {
                "_": Date.now(),
                "recid": vm.Recid,
                "UserName": vm.uid,               
                "UserFullName": vm.username,
                "Email": vm.emailaddress,
                "Phonenumber": vm.phonenumber,
                "FirstName": vm.firstname,
                "LastName": vm.lastname,
                "ClinicNo": vm.SelectedClinic.value,
                "EndDate": vm.toDate,
                "ServiceID": vm.selectService,
                "RoleID": vm.RoleID
                } 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                 // //console.log(response)
                  if(response.status ==200)
                  {
                    if(response.data.succeeded)
                    {
                          vm.succeeded = true;
                          vm.Msg= vm.uid + ": successfully updated in to the system.";  
                           vm.showModal=true;  
                    }
                    else if(!response.data.succeeded)
                    {
                          
                          vm.succeeded = false;
                          vm.Msg= response.data.errors;  
                          vm.showModal=true;
                    }
                    else
                    {
                          vm.succeeded = false;
                          vm.Msg="System Error; User is not successfully saved."; 
                           vm.showModal=true; 
                    }
                  }
                  else
                  {
                        vm.succeeded = false;
                        vm.Msg="System Error; User is not successfully saved."; 
                          vm.showModal=true; 
                  }
                   
                })
                .catch(function (error) {
                    if (error.response) {
                     ////console.log(error.response.data);
                      ////console.log(error.response.status);
                      if(error.response.status ==500)
                      {                   
                          vm.succeeded = false;
                          vm.Msg="System Error; User is not successfully saved."; 
                          vm.showModal=true; 
                      }
                      ////console.log(error.response.headers);
                    }
                    //console.log(error)
                }); 
          }
        },
        Exit: function (event) {
          this.$root.$emit('bv::hide::modal', 'modalAddEdit', '#btnShow')
        }, 
        fillroles(){
            var vm = this;
            var params = new URLSearchParams();
             params.append('ServiceID', this.selectService);
             axios.get('SaskHealthApi/Security/GetRolesWithoutCommunity', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             //axios.get('/SaskHealthApi/Codes/GetUserRoles')
                .then(function (response) {
                    //console.log(response.data);
                    //alert(vm.Roles)
                    vm.Roles = response.data
                    //alert(vm.Roles)
                   // //console.log(response);
                })
            .catch(function (er) {
                //console.log(er)
            })
        }, 

        PopMsgClose(){
          this.showModal=false;
          if(this.succeeded)
          {
            ////console.log('at emit')
             this.$emit('finished');
             //this.$root.$emit('bv::hide::modal', 'modalAddEdit', '#btnShow')
              
          } 
        },
        GetServices(){
          var vm = this;
          axios.get('/SaskHealthApi/Codes/GetServices', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
          .then(function (response) {
                     ////console.log(response.data);
                      //alert(vm.Services)
                      vm.Services = response.data;
                      //alert(vm.Services)
                    // //console.log(response);
                  })
              .catch(function (er) {
                  //console.log(er)
              }).then(function () {
                //vm.selectService =   
            }); 
        },
        GetLocations(){
           var vm = this;
           axios.get('/SaskHealthApi/Codes/GetClinics', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
                .then(function (response) {
                    //console.log(response.data);
                    vm.Locations = response.data
                   // //console.log(response);
                })
            .catch(function (er) {
                //console.log(er)
            }).then(function () {
               
                vm.SelectedClinic = vm.Locations.find(x=>x.value === vm.UserClinicNo); 
               // vm.SelectedCode ={"servicecode": vm.ServiceCodeInfo.servicecode , "servicedesc": vm.ServiceCodeInfo.description  }
                vm.$refs.SearchClinic.inputValue = vm.SelectedClinic.text;
                vm.UserServiceId = vm.SelectedClinic.serviceid;
                //console.log(vm.SelectedClinic) 
            }); 
        },
         showMsg(msg,data,Title) {
          this.boxTwo = ''
          this.$bvModal.msgBoxOk(msg, {
          title: Title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',          
          okTitle: 'Close', 
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            this.boxTwo = value
            if(value)
            {
             
            }
          })
          .catch(err => {
            // An error occurred
          })
      },
  },

   //Get Service Type values from Services Table
   mounted: function () {
     this.$nextTick(function () { 
        this.GetServices();
        this.GetLocations();
      })
    },

  created: function()
  {
    //console.log(this.UserData);
    this.DateFormat= this.$store.getters.GetDateFormat;
    this.PWDminLength= this.$store.getters.GetPwdMinLength;
    this.UserClinicNo = this.UserData.ClinicNo;
  // this.searchloc = this.UserData.ClinicNo.toISOString;
    this.uid = this.UserData.UserName;
    this.username = this.UserData.UserFullname; 
    this.firstname = this.username.substring(0, this.username.indexOf("|"));
    this.lastname = this.username.slice(this.username.indexOf("|") + ("|").length);
    this.phonenumber = this.UserData.PhoneNumber;
    this.emailaddress = this.UserData.Email;
    this.toDate = this.UserData.ExpiryDate;
    this.Recid = this.UserData.Recid;
    this.ServiceType = this.UserData.ServiceType; 
    this.RoleID = this.UserData.RoleId;
    //console.log("Record id  = " + this.Recid)
    
    var toDateCheck = this.toDate = moment(this.toDate,"YYYY-MM-DD").format('YYYY/MM/DD');
    if(this.todayDate > toDateCheck){
            this.IsPast = true;
      }
    
  }, 
  computed:
  { 
      filteredLocations:function()
      {
       var self=this;
       ////console.log('this.Locations')
       /////console.log(this.Locations)
       return this.Locations.filter(function(clinic){return clinic.Locations.toLowerCase().indexOf(self.searchloc.toLowerCase())>=0;});
       
      }      
  },
  validations(){
      return { 

            uid:{
              required,
               minLength: minLength(7),
                maxLength: maxLength(7),
            },
             username:{
              
               minLength: minLength(3),
                maxLength: maxLength(50),
            },
            selectService:{ 
               required,
            },

            SelectedClinic:{
              //required,
            },
            firstname:{
               maxLength: maxLength(25),
            },
            lastname:{
              maxLength: maxLength(25),
            },
            emailaddress:{
            email: (val) => email(emailFormatter(val))
            },
            phonenumber:{
            isPhone
            }
            
      }
  }  
}
</script>

<style scopped>
.calendarCss {
width: 200px; 
padding: 0 !important;
margin: 0 !important;
background: #f3fafe;
}
  .form-control-xs {
    height: calc(1.7em + .350rem + 1px) !important;
    padding: .150rem .25rem !important;
    font-size: .75rem !important;
    line-height: 1.5;
    border-radius: .2rem;
}
.label-small {
  vertical-align: super;
  font-size: small;
}

.modal-header {
    
    padding: .25rem !important;
    align-content: center;
    text-align: center !important;
}
.modal-footer
{
  padding: .75rem !important;
}
.form-group {
  margin-bottom: 0;
}
 /* @media (max-width: 600px) {
    .dropdown-menu{
          max-height:200px;
          overflow-y:auto;
       }
    } */
</style>
